import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MaterialModule} from './material/material.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SweetalertComponent} from './sweetalert/sweetalert.component';
import {ProcessingComponent} from './processing/processing.component';
import {Select2Component} from './select2/select2.component';
import {OpacityComponent} from './opacity/opacity.component';
import {BootstrapModule} from './bootstrap/bootstrap.module';
import {OficinaModule} from './oficina/oficina.module';
import {HighchartsChartModule} from 'highcharts-angular';
import {ChartsModule} from 'ng2-charts';
import {FileModule} from './file/file.module';
import {HttpClientModule} from "@angular/common/http";
import {NgxMaskModule} from "ngx-mask";
import { PersonaSelectComponent } from './persona-select/persona-select.component';

const COMPONENTS = [
	SweetalertComponent,
	ProcessingComponent,
	OpacityComponent,
	Select2Component,
	PersonaSelectComponent
];

const MODULES = [
	CommonModule,
	MaterialModule,
	BootstrapModule,
	RouterModule,
	OficinaModule,
	FileModule,
	HighchartsChartModule,
	ChartsModule,
	FormsModule,
	ReactiveFormsModule,
	HttpClientModule,
	NgxMaskModule,
];

@NgModule({
	declarations: [
		COMPONENTS
	],
	imports: [
		MODULES
	],
	exports: [
		COMPONENTS,
		MODULES
	]
})
export class SharedModule {
}
